import { gql } from 'apollo-angular';

export const SEARCH_CAMPAIGNS_COLLECTORS_LIST = gql`
  query ($criteria: SearchCampaignCollectorsCriteria!) {
    campaignCollectors(criteria: $criteria) {
      id
      campaignId
      collectorId
      status
      customerCaseCount
    }
  }
`;

export const SEARCH_CAMPAIGN_COLLECTORS_CRITERIA = gql`
  query ($criteria: SearchCampaignCollectorsCriteria!) {
    campaignCollectors(criteria: $criteria) {
      id
      campaignId
      collectorId
      status
      customerCaseCount
    }
  }
`;

export const CREATE_CAMPAIGN_COLLECTOR = gql`
  mutation ($input: CreateCampaignCollectorInput!) {
    createCampaignCollector(input: $input) {
      id
      campaignId
      collectorId
    }
  }
`;

export const DELETE_CAMPAIGN_COLLECTOR = gql`
  mutation ($input: DeleteCampaignCollectorInput!) {
    deleteCampaignCollector(input: $input) {
      id
    }
  }
`;

export const PAUSE_CAMPAIGN_COLLECTOR = gql`
  mutation ($input: PauseCampaignCollectorInput!) {
    pauseCampaignCollector(input: $input) {
      id
    }
  }
`;

export const RESUME_CAMPAIGN_COLLECTOR = gql`
  mutation ($input: ResumeCampaignCollectorInput!) {
    resumeCampaignCollector(input: $input) {
      id
    }
  }
`;

export const UNPUBLISH_CAMPAIGN_COLLECTOR = gql`
  mutation ($input: UnpublishCampaignCollectorInput!) {
    unpublishCampaignCollector(input: $input) {
      id
    }
  }
`;
